import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { UNIVERSITY_ID } from "@/constants/admin";
import adminAxios from "@/lib/axios";

export interface IUniversitySettings {
  id?: number;
  university_id?: number;
  section?: string;
  variant?: string;
  is_active?: boolean;
}

/**
 * Get all university settings
 */
export async function getAllUniversitySettings() {
  try {
    const response = await adminAxios.get(
      ADMIN_API_ENDPOINTS.UNIVERSITY_SETTINGS.GET_BY_UNIVERSITY_ID(UNIVERSITY_ID)
    );
    // APIResponse wraps data in { success: true, data: ... }
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Get university settings by section
 */
export async function getUniversitySettingsBySection(section: string) {
  try {
    const response = await adminAxios.get(
      ADMIN_API_ENDPOINTS.UNIVERSITY_SETTINGS.GET_BY_UNIVERSITY_AND_SECTION(UNIVERSITY_ID, section)
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Upsert university settings (update if exists, create if not)
 * @param section - Section type (e.g., "26" for LEAD_DROP_POPUP)
 * @param variant - Variant ID (e.g., "1", "2")
 * @param isActive - Whether this variant is active
 */
export async function upsertUniversitySettings(
  section: string,
  variant: string,
  isActive: boolean
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.UNIVERSITY_SETTINGS.UPDATE_BY_UNIVERSITY_ID(UNIVERSITY_ID),
      { section, variant, is_active: isActive }
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Create university settings
 */
export async function createUniversitySettings(
  payload: Partial<IUniversitySettings>
) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.UNIVERSITY_SETTINGS.CREATE_BY_UNIVERSITY_ID(UNIVERSITY_ID),
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
